import axios from 'axios'

import firebase from 'firebase/app'
import { initializeApp } from 'firebase/database'

const env = process.env
const cohort = env.VUE_APP_COHORT

const firebaseConfig = {
    apiKey: env.VUE_APP_API_KEY,
    authDomain: env.VUE_APP_AUTH_DOMAIN,
    databaseURL: env.VUE_APP_DB_URL,
    projectId: env.VUE_APP_PROJECT_ID,
    storageBucket: env.VUE_APP_STORAGE_BUCKET,
};

firebase.initializeApp(firebaseConfig)  

export const getTracks = async (gene) => {
    if (gene.length === 0) {
        return []
    }

    // Database connection setup successfully
    // functionality has been damaged though

    // Note: changed from k_gene_v_tracks to avoid scatterplot not working error
    // invalid inputs being passed in, meaning this function wasnt working properly
    const path = `protrack/${cohort}/k_gene_v_availableTracks/${gene}`

    const ref = firebase.database().ref(path)
    const series = await ref.once('value')
        .then((snapshot) => {
            return snapshot.val()
        })

    return [gene, series]
}

export const getTrackData = async (track) => {
    if (!track || track.length === 0) {
        return [track, {}]
    }

    // Poorly named path
    // The path below actually maps a track to the trackData
    const path = `protrack/${cohort}/k_gene_v_tracks/${track}`

    const ref = firebase.database().ref(path)
    const series = await ref.once('value')
        .then((snapshot) => {
            return snapshot.val()
        })
    
    return [track, series]
}
